<button *ngIf="loading" [ngClass]="model.obbligatorio ? 'btn-mandatory' : 'btn-not_mandatory'" class="btn btn-primary"
  type="button" disabled>
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <span class="sr-only">Loading...</span>
</button>
<p-fileUpload [hidden]="loading" mode="basic" [auto]="true" [chooseLabel]="label" name="file" url="/api/v1/file"
  (onUpload)="onUpload($event)"  [multiple]="false" [accept]="accept" (onSelect)="onSelect()" (onError)="onFinish()"  [maxFileSize]="10000000">
</p-fileUpload>